import React from "react";
import { View, ScrollView, Pressable, Text, Platform } from "react-native";
import { styles, ids } from "./style";

import NavigationBar from "../../components/navigationBar/NavigationBar";
import commonStyle from "../../assets/styles/common-style";
import { description } from "../../resources/strings";
import useDeleteAccount from "@lib/hooks/deleteAccount/useDeleteAccount";
import MainContainer from "../../components/common/MainContainer";
import {
  isGradientAllowed,
  isOpaqueStripeDisabled,
  ScreenNameList,
} from "@lib/utilities/Constants";
import { getBackgroundColor } from "@lib/utilities/HelperFunctions";
import GradientBackground from "src/components/gradient-background/GradientBackground";

const DeleteAccount = ({ navigation }: any) => {
  const {
    deleteAccountDescData,
    isContinuePressed,
    submitButtonAction,
    errorData,
    onEndTimer,
  } = useDeleteAccount();

  const ViewContent = () => {
    return (
      <ScrollView
        bounces={false}
        style={[styles.scrollArea]}
        dataSet={{ media: ids.scrollArea }}
      >
        <View style={[styles.outerBlock]} dataSet={{ media: ids.outerBlock }}>
          <View style={[styles.innerBlock]} dataSet={{ media: ids.innerBlock }}>
            {isContinuePressed ? (
              <>
                <Text
                  style={[styles.lineText]}
                  dataSet={{ media: ids.lineText }}
                >
                  {description.delete.description5}
                </Text>
              </>
            ) : (
              <>
                <Text
                  style={[styles.heading]}
                  dataSet={{ media: ids.heading }}
                  testID="delete-page-header-label"
                >
                  {description.delete.heading}
                </Text>
                {deleteAccountDescData.map((item: string, index: number) => (
                  <View
                    style={styles.lineWrapper}
                    dataSet={{ media: ids.lineWrapper }}
                    testID={`delete-page-points-container`}
                  >
                    <Text
                      style={[styles.lineText]}
                      dataSet={{ media: ids.lineText }}
                      testID={`delete-page-points`}
                    >
                      {index + 1}.
                    </Text>
                    <Text
                      style={[styles.lineText, styles.line]}
                      dataSet={{ media: ids.lineText }}
                      testID={`delete-page-points-label`}
                    >
                      {item}
                    </Text>
                  </View>
                ))}
              </>
            )}

            <Pressable
              onPress={() => {
                submitButtonAction();
              }}
              style={[isContinuePressed ? styles.deleteBtn : styles.submitBtn]}
              dataSet={{
                media: isContinuePressed ? ids.deleteBtn : ids.submitBtn,
              }}
              testID="delete-page-continue-delete-button"
            >
              <Text
                style={[styles.btnText]}
                dataSet={{ media: ids.btnText }}
                testID="delete-page-continue-delete-button-label"
              >
                {isContinuePressed ? "Delete Account" : "Continue"}
              </Text>
            </Pressable>
          </View>
        </View>
      </ScrollView>
    );
  };

  if (isGradientAllowed && Platform.OS !== "web") {
    return (
      <MainContainer
        screenName={errorData.screenName}
        navigation={navigation}
        errorData={errorData}
        onEndTimer={onEndTimer}
      >
        <GradientBackground styles={commonStyle.styles.coverImage}>
          <View
            style={[styles.mainContainer]}
            dataSet={{ media: ids?.mainContainer }}
          >
            <NavigationBar
              data={{ screenName: ScreenNameList.deleteAccount }}
              barNavigation={navigation}
            />

            {ViewContent()}
          </View>
        </GradientBackground>
      </MainContainer>
    );
  }
  return (
    <MainContainer
      screenName={errorData.screenName}
      navigation={navigation}
      errorData={errorData}
      onEndTimer={onEndTimer}
    >
      <View
        style={[
          styles.mainContainer,
          { backgroundColor: getBackgroundColor(ScreenNameList.contactAgent) },
          isGradientAllowed && styles.gradientBg,
        ]}
        dataSet={{ media: ids?.mainContainer }}
      >
        {Platform.OS == "web" && !isOpaqueStripeDisabled && (
          <View
            style={[
              styles.bgEffect,
              {
                backgroundColor: getBackgroundColor(
                  ScreenNameList.contactAgent,
                  true,
                ),
              },
            ]}
            dataSet={{ media: ids.bgEffect }}
          />
        )}
        <NavigationBar
          data={{ screenName: ScreenNameList.deleteAccount }}
          barNavigation={navigation}
        />

        {ViewContent()}
        {Platform.OS == "web" && !isOpaqueStripeDisabled && (
          <View
            style={[commonStyle.styles.bgEffectBottom]}
            dataSet={{ media: commonStyle.ids.bgEffectBottom }}
          />
        )}
      </View>
    </MainContainer>
  );
};

export default DeleteAccount;
